module.exports = __webpack_public_path__ + "img/hero_fullwidth.d8ac716f.png";